import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

import EN_translation from './en/translation.json';

// Don't want to use this?
// Have a look at the Quick start guide
// For passing in lng and translations on init
const resources = {
  en: {
    translation: {
      ...EN_translation,
    },
  },
};
i18next
  // Load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // Learn more: https://github.com/i18next/i18next-http-backend
  // Want your translations to be loaded from a professional CDN? => https://github.com/locize/react-tutorial#step-2---use-the-locize-cdn
  // .use(Backend)
  // Pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // Init i18next
  // For all options read: https://www.i18next.com/overview/configuration-options
  .init({
    lng: 'en',
    debug: process.env.NODE_ENV !== 'test',
    resources,
    returnNull: false,
    interpolation: {
      escapeValue: true, // Not needed for react as it escapes by default
    },
  });

// NOTE: we re-export here because the above code is an initializer with side effects and importing directly from the
// npm module bypasses this. there's got to be a better pattern here?
// oxlint-disable-next-line no-barrel-files/no-barrel-files
export default i18next;
